// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require(63);
$export($export.S, 'Object', { setPrototypeOf: require(106).set });
